<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Physician</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Physician</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="tab-pane active" id="home2" role="tabpanel">
            <div class="table-responsive">
              <table
                id="table002"
                data-height="300"
                class="
                  table
                  display
                  table-bordered table-striped
                  no-wrap
                  noSearch
                "
              >
                <thead class="thead-dark text-center">
                  <tr>
                    <th>Physician</th>
                    <th>Name & DOB</th>
                    <th>Email</th>
                    <th>Phone</th>
                  </tr>
                </thead>

                <tbody class="text-center">
                  <tr v-for="ph in phInfo" :key="ph.cid">
                    <td>
                      <div class="col-lg-3 switchery-demo">
                        <label class="switch text-center">
                          <input
                            class=""
                            :id="'swPh' + ph.cid"
                            type="checkbox"
                            v-model="ph.isPhysicianActive"
                            @change="physicianActiveChange(ph)"
                            :disabled="updButton == 0"
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </td>
                    <td>
                      {{ ph.firstName }} {{ ph.lastName }}<br />
                      {{ ph.dob.substring(0, 10) }}
                    </td>
                    <td>
                      {{ ph.email }}
                    </td>
                    <td>{{ ph.phone }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Physicians",

  data() {
    return {
      //loader
      loader: "",
      //Timer
      TimerObject: {},
      phInfo: [],
      //list
      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,
    };
  }, // end data()

  methods: {
    physicianActiveChange(ph) {
      //debugger
      this.intDummyComm();
      this.dummyComm.extras =
        ph.cid + this.UKEY + (ph.isPhysicianActive ? "1" : "0");
      this.dummyComm.patientId = ph.userId;
      const obj = {
        DC: this.dummyComm,
        Physician: ph,
      };
      const url = this.SERVER + "/VNSPRAAPI/Practices/UpdatePhysicianStatus";

      this.physicianAxiosChange(url, obj);
    },
    async physicianAxiosChange(myUrl, data) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: myUrl,
        data: data,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          loader.hide();
          this.lastErrorCode = 1;
          this.dummyComm = res.data;
          if (this.dummyComm < 0) {
            alert(this.dummyComm.auditFlagVal);
          }
        })
        .catch(function(error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
          //this.lastErrorCode = this.lastErrorCode;
        });
    }, // physican change

    handleRole() {
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if (this.EmployeeRolesStr.length > 0) {
        this.val = this.EmployeeRolesStr.filter((i) => i.optionId == 1100);
        if (this.val[0].canUpdate == 0) {
          this.updButton = 0;
        }
      }
    },

    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    //loader
    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },

    loadInit() {
      //alert(localStorage.OSversion);
      this.intDummyComm();

      //this.dummyComm.pure = this.m_makeCommString('6001', 'r');

      const url = this.SERVER + "/VNSPRAAPI/Practices/GTPHINF";
      this.lastErrorCode = -1;

      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          loader.hide();
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
            //debugger // eslint-disable-line no-debugger
            this.phInfo = res.data.ph;
          } else if (what == 2) {
            this.dummyComm = res.data;
            if (this.dummyComm < 0) alert(this.dummyComm.auditFlagVal);
          }
        })
        .catch(function(error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
          //this.lastErrorCode = this.lastErrorCode;
        });
    }, // axiosGetData
  }, // methods

  mounted() {
    if (this.$store.getters.getAuthToken === "") {
      this.$store.commit("setAuthToken", localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    this.handleRole();
    this.loadInit();
  },
  unmounted() {
    clearTimeout(this.TimerObject);
  },

  watch: {
    phInfo: function() {
      this.$nextTick(() => {
        $("#table002")
          .DataTable()
          .destroy();
        $("#table002").DataTable({
          pageLength: 50,
          lengthMenu: [
            [50, 100, 500, 1000, 2000],
            [50, 100, 500, 1000, 2000],
          ],
        });
        $(
          ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
        ).addClass("btn btn-primary mr-1");
        $(".table002")
          .DataTable()
          .draw();
      }); // this.$nextTick
    }, // phInfo
  }, // watch
};
</script>

<style>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #00c292;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00c292;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  height: 34px;
  width: 60px;
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
